export const DRAWER_CONTENT_ATTRIBUTE = 'data-drawer-content';
